module.exports = __webpack_public_path__ + "static/media/Bar1.8a7c7bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bar1.png
// module id = 130
// module chunks = 0